module.exports = __webpack_public_path__ + "img/d6f2f55f949931632ad58b2364ea750d.png";